module.exports = __webpack_public_path__ + "img/znqm.3c1e0918.jpg";